import { createContext, useContext } from 'react';
import type { MerchantProductItem } from '../service/types';

export interface InventoryResultsContextValue {
  isTableLoading: boolean;
  isError: boolean;
  isRetrying: boolean;
  error: unknown;
  isOwner: boolean;
  rows: MerchantProductItem[];
  needsPhotoCount: number;
  missingImage: boolean;
  onShowNeedsPhoto: () => void;
  selectedIds: string[];
  selectedCount: number;
  isAllRowsSelected: boolean;
  isSomeRowsSelected: boolean;
  canRunBulkActions: boolean;
  isBulkUpdating: boolean;
  bulkCategory: string;
  bulkCategoryOptions: ReadonlyArray<{ value: string; label: string }>;
  totalRows: number;
  hasAnyRows: boolean;
  showPagination: boolean;
  isAllProductsLoaded: boolean;
  pageItems: Array<number | 'ellipsis'>;
  pageNumber: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onPageChange: (nextPage: number) => void;
  onRowSelectionChange: (productId: string, checked: boolean) => void;
  onToggleSelectAllRows: (checked: boolean) => void;
  onBulkCategoryChange: (nextCategory: string) => void;
  onBulkHideSelected: () => void;
  onBulkApplyCategory: () => void;
  onRetry: () => void;
}

export const inventoryResultsContext = createContext<InventoryResultsContextValue | null>(null);

export function useInventoryResults() {
  const value = useContext(inventoryResultsContext);
  if (value === null) {
    throw new Error('useInventoryResults must be used within InventoryPageProvider');
  }

  return value;
}
